<div class="recent-orders">
    <div class="title-buttons">
        <strong>{{ title }}</strong>
    </div>
    <br />
    <br />
    <p *ngIf="loading; else partnerForm">Loading ...</p>
    <ng-template #partnerForm>
        <div class="table-responsive">
            <div class="form-page-block">
                <div class="card">
                    <div class="card-header">
                        <span>&nbsp;</span>
                    </div>
                    <div class="card-body">
                        <form class="form-page" [formGroup]="form" (ngSubmit)="save()">
                            <input type="hidden" formControlName="id" />
                            <div class="form-group">
                                <label>Partner Name <span class="required">*</span> </label>
                                <input type="text" class="form-control" formControlName="clientPartnerName" />
                            </div>
                            <div class="form-group mt-3">
                                <label>Logo <span *ngIf="!partnerId" class="required">*</span> </label><br>
                                <input type="file" formControlName="logo" (change)="onChangeFile($event)" accept="image/*" />
                            </div>
                            <div class="form-group mt-3" *ngIf="previewUrl || existingLogoUrl">
                                <label>Preview</label><br>
                                <img *ngIf="previewUrl" [src]="previewUrl" style="max-height: 120px; max-width: 200px; object-fit: contain;" />
                                <img *ngIf="!previewUrl && existingLogoUrl" [src]="existingLogoUrl" style="max-height: 120px; max-width: 200px; object-fit: contain;" />
                            </div>
                            <div class="button-set mt-3">
                                <button [disabled]="form.invalid || submitting" class="btn btn-success" id="btn-submit" type="submit">
                                    Save
                                </button>
                                &nbsp;
                                <span *ngIf="submitting">saving ...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
